import { ViewChild,Component, Directive, OnInit, NgZone,Inject, Input, Output, EventEmitter,OnDestroy, ViewEncapsulation } from '@angular/core';
import {Location} from "@angular/common";
import {Observable} from "rxjs";
import * as Communication from '../communication/index';
import {Router, ActivatedRoute} from '@angular/router';
import { Config } from '../../environments/environment';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {ToolbarService} from "../shared/common/ToolbarEventService";
import {NotificationService} from "../shared/common/NotificationService";
import {FileConversionService} from "../shared/common/FileConversion.service";
import {ToolbarEventPageEnum, ToolbarEvent} from "../shared/common/ToolbarEvent";
import {NavigationService} from "../shared/common/NavigationEventService";
import {NavigationEvent} from "../shared/common/NavigationEvent";
import { Subscription } from 'rxjs';
import {Authorization} from "../shared/authorization/authorization.component";
import {TranslateService} from '@ngx-translate/core';
import Uppy, { AsyncStore } from '@uppy/core';
import Dashboard from '@uppy/dashboard';
import XHRUpload from '@uppy/xhr-upload';
import GoogleDrivePicker from '@uppy/google-drive-picker';
import UppyBox from '@uppy/box';
import Turkish from '@uppy/locales/lib/tr_TR';
import English from '@uppy/locales/lib/en_US';
import { createInMemoryTokenStore } from '../shared/common/InMemoryTokenStore';

declare var $:any;
declare var Box: any;
declare var BoxSelect:any;


/**
 * This class represents the lazy loaded CombineComponent.
 */
@Component({
    selector: 'sd-combine',
    templateUrl: 'combine.component.html',
    styleUrls: [
      'combine.component.css',
      '../../../../node_modules/@uppy/core/dist/style.css',
      '../../../../node_modules/@uppy/dashboard/dist/style.css',
    ],
    providers: [Communication.JobsService, Communication.DocumentsService, Communication.RecipientRequestService],
    standalone: false,
    encapsulation: ViewEncapsulation.None,
})

export class CombineComponent implements OnInit, OnDestroy {
  screenState: string = ""; // INITIAL -> UPLOADING -> FINISHED
  jobIDParameter:number;
  requestCode:string;
  theJob:Communication.Job;
  subscriptions:Subscription[] = [];
  uploadStatus = {"basladi": false, "bitti": false};

  sizeLimit = 100 * 1024 * 1024; //100MB
  progress:number;
  hasBaseDropZoneOver:boolean = false;
  @Output() hideModal = new EventEmitter();

  //ngx-uploader objects
  startUploadEvent: EventEmitter<any>;
  cloudStartUploadEvent: EventEmitter<any>;
  cloudOptions: any = null;

  uploadResponse: any;
  isErrorShown:boolean;

  driveFSize:number;

  // Non-persistent, self-expiring store for the Google Drive picker OAuth token.
  private drivePickerStore: AsyncStore = createInMemoryTokenStore();

  tagItems:string[] = [];
  jobNewName:string="";
  returnUrl:string="";
  reachedMaxUpload:boolean=false;
  mainDocId:number;

  cloudFile:any = {
    "xhr":null,
    "fileName": "",
    "fileSize": "",
    "progress" : 0,
    "status": ""
  };

  sortableItems:Array<Communication.Document> = [];

  // Uppy file upload
  uppy: Uppy;
  uppyDashboardOptions = {};

  // Track ongoing Office file conversions
  private pendingConversions: number = 0;

  // Helper function to format bytes
  humanizeBytes(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  constructor(private jobsApi:Communication.JobsService,
              private documentsApi:Communication.DocumentsService,
              private activatedRoute:ActivatedRoute,
              private router:Router,
              private location:Location,
              private navigationService:NavigationService,
              private zone:NgZone,
              private toolbarService: ToolbarService,
              private authorization: Authorization,
              private notificationService: NotificationService,
              private translate: TranslateService,
              private fileConversionService: FileConversionService,
  ) {

    //XMLHttpRequest.DONE = 4;
    this.theJob = null;
    this.progress = 0;

    this.startUploadEvent = new EventEmitter();
    this.cloudStartUploadEvent = new EventEmitter();

    // Initialize Uppy
    this.uppy = new Uppy({
      debug: true,
      autoProceed: true,
      locale: this.translate.currentLang === 'tr' ? Turkish : English,
      restrictions: {
        maxNumberOfFiles: 10,
        allowedFileTypes: [
          'image/*',
          'application/pdf',
          ...FileConversionService.OFFICE_FILE_TYPES,
        ],
      },
      onBeforeUpload: (files) => {
        // Block upload while Office file conversions are in progress
        if (this.pendingConversions > 0) {
          console.log(`[Uppy] Blocking upload - ${this.pendingConversions} conversion(s) in progress`);
          return false;
        }

        // Block upload if there are still Office files (shouldn't happen after conversion)
        for (const [id, file] of Object.entries(files)) {
          if (this.fileConversionService.isOfficeFile(file.name)) {
            console.log(`[Uppy] Blocking upload - Office file not yet converted: ${file.name}`);
            return false;
          }
        }

        return true;
      },
      onBeforeFileAdded: (currentFile, files) => {
        // Remove trailing spaces and dots before file extension (e.g., 'filename . .pdf' -> 'filename.pdf')
        const originalName = currentFile.name;
        const sanitizedName = originalName.replace(/[\s.]+(\.[^.]+)$/, '$1');
        console.log('[Uppy] Filename sanitized:', originalName, '->', sanitizedName);

        if (currentFile.size > this.sizeLimit) {
          this.notificationService.largeFileToUpload();
          return false;
        }

        // Check total size of all files (existing + new)
        let totalSize = currentFile.size;
        Object.keys(files).forEach(fileId => {
          totalSize += files[fileId].size;
        });

        if (totalSize > 200 * 1024 * 1024) {
          this.notificationService.largeFileToUpload();
          return false;
        }

        let match = FileConversionService.ALLOWED_FILE_REGEX.test(sanitizedName);
        if (!match) {
          this.notificationService.fileTypeNotMatchToUpload();
          return false;
        }

        // Block Office files from cloud providers (conversion not supported for remote files)
        const isRemoteFile = currentFile.isRemote || ['GoogleDrive', 'Box'].includes(currentFile.source as string);
        if (isRemoteFile && this.fileConversionService.isOfficeFile(sanitizedName)) {
          this.uppy.info(this.translate.instant('Office files from cloud storage must be downloaded and uploaded locally for PDF conversion'), 'error', 5000);
          return false;
        }

        // Return modified file object with sanitized name (Uppy requires returning the modified object)
        return {
          ...currentFile,
          name: sanitizedName,
          meta: {
            ...currentFile.meta,
            name: sanitizedName,
          },
        };
      }
    });

    this.uppyDashboardOptions = {
      replaceTargetContent: true,
      height: 200,
      showProgressDetails: true,
      proudlyDisplayPoweredByUppy: false,
      plugins: ['GoogleDrivePicker', 'Box'],
    };

    // Add cloud provider plugins
    this.uppy.use(GoogleDrivePicker, {
      companionUrl: Config.COMPANION_URL,
      clientId: Config.GOOGLE_PICKER_CLIENT_ID,
      apiKey: Config.GOOGLE_PICKER_API_KEY,
      appId: Config.GOOGLE_PICKER_APP_ID,
      // Non-persistent store — consumed at GoogleDrivePicker.js `this.opts.storage`.
      // `storage` is omitted from the public options type, hence the cast.
      storage: this.drivePickerStore,
    } as any);
    this.uppy.use(UppyBox, {
      companionUrl: Config.COMPANION_URL,
      companionAllowedHosts: [new URL(Config.COMPANION_URL).origin],
    });

    // Convert Office files to PDF when added
    this.uppy.on('file-added', async (file) => {
      if (this.fileConversionService.isOfficeFile(file.name)) {
        console.log(`[Uppy] Converting Office file to PDF: ${file.name}`);

        // Check if file data is available (local files have data immediately)
        if (file.data instanceof Blob) {
          this.pendingConversions++;
          console.log(`[Uppy] Pending conversions: ${this.pendingConversions}`);

          try {
            // Convert to PDF
            const pdfBlob = await this.fileConversionService.convertToPdf(file as { data: Blob; name: string });
            const pdfName = this.fileConversionService.getPdfFileName(file.name);

            console.log(`[Uppy] Conversion complete: ${file.name} -> ${pdfName}`);

            // Preserve original file's metadata
            const originalMeta = { ...file.meta };

            // Remove original Office file
            this.uppy.removeFile(file.id);

            // Add converted PDF
            this.uppy.addFile({
              name: pdfName,
              type: 'application/pdf',
              data: pdfBlob,
              source: file.source || 'Local',
              isRemote: false,
              meta: originalMeta,
            });
          } catch (error) {
            console.error(`[Uppy] Conversion failed for ${file.name}:`, error);
            this.uppy.removeFile(file.id);
            this.notificationService.displayError(`Failed to convert ${file.name} to PDF`);
          } finally {
            this.pendingConversions--;
            console.log(`[Uppy] Pending conversions after: ${this.pendingConversions}`);

            // If all conversions done, trigger upload manually
            if (this.pendingConversions === 0) {
              const files = this.uppy.getFiles();
              if (files.length > 0) {
                console.log(`[Uppy] All conversions complete, starting upload with ${files.length} file(s)...`);
                // Small delay to ensure state is updated
                setTimeout(() => this.uppy.upload(), 100);
              }
            }
          }
        }
        // Remote Office files are blocked in onBeforeFileAdded
      }
    });
  }

  ngOnInit() {

    if (!this.authorization.authenticated()) {
      this.router.navigate(['/']);
    } else {

      //this.zone = new NgZone({enableLongStackTrace: false});
      this.subscriptions.push(this.navigationService.eventOccured$.subscribe(
        (event: NavigationEvent) => this.onNavigationEvent(event)
      ));

      this.subscriptions.push(this.activatedRoute.params.subscribe(
        (param) => {
          this.jobIDParameter = param['jobid'];
          console.log("jobIDParameter:" + this.jobIDParameter);

          if(param['jobid'] == null){
            //TODO:ERROR
            this.notificationService.showAccessDenied();
            return;
          }

        })
      );

      this.GetTheJob();
      // Cloud providers (Google Drive, Box) are now handled by Uppy plugins
    }
  }

  public GetTheJob(){
    let accesToken:string = this.authorization.getAccessToken();
    this.reachedMaxUpload = false;

    // Save current order before fetching
    const currentOrderIds = this.sortableItems.map(doc => doc.id);

    this.subscriptions.push(this.jobsApi.jobsIdGet(accesToken, this.jobIDParameter).subscribe(
      (response:Communication.Job) => {

        // Preserve existing order and append new documents at the end
        if (currentOrderIds.length > 0) {
          const newDocs = response.documents;
          const orderedDocs: Communication.Document[] = [];

          // First, add documents in their current order
          for (const id of currentOrderIds) {
            const doc = newDocs.find(d => d.id === id);
            if (doc) {
              orderedDocs.push(doc);
            }
          }

          // Then, add any new documents at the end
          for (const doc of newDocs) {
            if (!currentOrderIds.includes(doc.id)) {
              orderedDocs.push(doc);
            }
          }

          this.sortableItems = orderedDocs;
        } else {
          this.sortableItems = response.documents;
        }

        this.initUploader();
        this.setJobSettings(response);

        if(response.documents.length >= 10)
          this.reachedMaxUpload = true;

      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
  }

  setJobSettings(response:Communication.Job){

    let dumpJob = response;

    let userEmail = this.authorization.userProfile.email;
    if (userEmail != response.user.email)
    {
      for (let recipient of response.recipients) {
        if (userEmail == recipient.email) {
          dumpJob.name = recipient.jobNameForRecipient;
        }
      }
    }

    this.theJob = dumpJob;
    if(this.jobNewName == "")
      this.jobNewName = this.theJob.name;
    this.mainDocId = this.theJob.documents[0].id;

    //set title
    this.toolbarService.action(new ToolbarEvent(ToolbarEventPageEnum.COMBINE, response.type, response.user.id, "", response.name, response.status, "", "", ""));

  }

  updateLabels(){

    this.subscriptions.push(this.jobsApi.jobsIdPut(this.authorization.getAccessToken(), this.theJob.id, this.theJob.tags.toString(), this.jobNewName).subscribe(
      (response:Communication.Job) => {
        console.log("name updated... ");
        this.setJobSettings(response);
        this.combine();
      },
      (err:any) => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
  }

  private initBox(){
    let self = this;
    let boxSelect = new BoxSelect();

    // Register a success callback handler
    boxSelect.success(function(response:any) {
      console.log("selected::\nid: " + response[0].id + "\nsize: " + Number(response[0].size)/1024 + " KB\nname: " +response[0].name + "\nurl: " + response[0].url);

      let isSuitToDownload:boolean = true;

      if (Number(response[0].size) > self.sizeLimit) {
        isSuitToDownload = false;
        self.notificationService.largeFileToUpload();
      }

      let match = (/\.(gif|jpg|jpeg|png|pdf)$/i).test(response[0].name);
      console.log("file type match: " + match);

      if (!match) {
        isSuitToDownload = false;
        self.notificationService.fileTypeNotMatchToUpload();
      }

      // file type and size appropriate
      setTimeout(() => {
        if (isSuitToDownload) {
          self.screenState='UPLOADING';
          self.cloudFile.fileName = response[0].name;
          self.cloudFile.fileSize = self.humanizeBytes(Number(response[0].size));
          self.cloudFile.status = "Receiving file";

          let authToken = {token: ""};
          self.toDataURL(response[0].url, authToken, function (dataUrl: any) {
            // console.log('RESULT:', dataUrl);
            self.upload(dataUrl, response[0].name, "BOX");
          });
        }
      },100)

    });

    // Register a cancel callback handler
    boxSelect.cancel(function() {
      console.log("The user clicked cancel or closed the popup");
    });

  }


  upload(blobOrFile:any, fileName:string, source:string) {

    let tmpB64String = encodeURIComponent(blobOrFile);
    this.cloudFile.status = "Uploading file";
    this.cloudFile.progress = 0;

    let xhr = new XMLHttpRequest();
    let self = this;
    self.cloudFile.xhr = xhr;

    xhr.onload = function() {
      self.screenState = "FINISHED";

      if(xhr.status == 200) {

        console.log("The transfer is complete.");
        self.cloudFile.status = "File uploaded";

        self.cloudFile.status = "";
        self.cloudFile.progress = 0;
        self.cloudFile.fileName = "";
        self.cloudFile.fileSize = 0;
        self.GetTheJob();
      }else{
        let uploadResponse = JSON.parse(xhr.response);
        console.log("Error during cloud upload: " + xhr.response);

        //if error occurs
        if(uploadResponse.hasOwnProperty('code')) {
          //console.log("response " + self.uploadResponse.description);
          self.cloudFile.status = "";
          self.cloudFile.progress = 0;
          self.notificationService.displayError(uploadResponse.description);
          self.initUploader();
        }
      }
    };

    let params = "fileName="+fileName + "&fileData="+tmpB64String + "&source="+source;

    xhr.open('POST', Config.WEBSERVICEURL + '/jobs/' + this.theJob.id + '/documents/cloud');

    xhr.upload.addEventListener("progress", function(e:any){
      if (e.lengthComputable) {
        self.cloudFile.progress = ((e.loaded / e.total) *100 ).toString().split('.')[0];
        //console.log("Uploaded:..." + e.loaded + "/" + e.total);
      }
    }, false);

    xhr.setRequestHeader('access_token', String(this.authorization.getAccessToken()));
    xhr.setRequestHeader('Content-Type',  'application/x-www-form-urlencoded' /*'application/json' 'text/plain' */);

    // Send the data
    xhr.send(params);

  }


  toDataURL(url:any, authToken:any, callback:any) {

    let xhr = new XMLHttpRequest();
    let self = this;
    self.cloudFile.xhr = xhr; // to cancel download

    xhr.onprogress = function(e:any) {

      if (e.lengthComputable) {
        self.cloudFile.progress = ((e.loaded / e.total)*100).toString().split('.')[0];
      } else if(self.driveFSize){
        self.cloudFile.progress = ((e.loaded /self.driveFSize)*100).toString().split('.')[0];
        console.log(self.cloudFile.progress, self.cloudFile.status)
      } else {
        self.cloudFile.status = "Unable to compute progress information since the total size is unknown";
      }
    };

    xhr.onload = function() {
      console.log("The transfer is complete.");
      self.cloudFile.status = "File received";

      let reader = new FileReader();
      reader.onloadend = function() {
        callback(reader.result);
      }

      reader.readAsDataURL(xhr.response);
    };

    xhr.onabort = function(e:any) {
      console.log("The transfer has been canceled by the user.");
      self.cloudFile.status = "The transfer has been canceled by the user.";
    };

    xhr.onerror = function(e:any) {
      console.log("An error occurred while transferring the file.");
      self.cloudFile.status = "An error occurred while transferring the file.";
    };

    xhr.open('GET', url);
    if(authToken.token != "")
      xhr.setRequestHeader('Authorization', 'Bearer ' + authToken.token);
    xhr.responseType = 'blob';
    xhr.send();

  }

  onUploadOutput(output: any/*UploadOutput*/) {
    switch (output.type) {
      /*case 'allAddedToQueue':{
        this.uploadInput.emit({
          type:"uploadAll",
          url: Config.WEBSERVICEURL + '/jobs/' + this.jobIDParameter + '/documents',
          method:"POST",
          headers:{
            'access_token': this.authorization.getAccessToken()
          },
          id:this.jobIDParameter.toString()
        });
      } break;
      case 'addedToQueue':{
        console.log("addedToQueue")
        if (typeof output.file !== 'undefined') {
          this.beforeUpload(output.file);
        }
      } break;
      case 'uploading':{
        console.log("uploading")
        if (typeof output.file !== 'undefined') {
          this.uploadFile = output.file
        }
      } break;
      case 'start':{
        console.log("start")
        this.handleUpload(output.file);
        console.log(output)
      } break;
      case 'dragOver': {
        this.hasBaseDropZoneOver = true;
      } break;
      case 'dragOut':{
        this.hasBaseDropZoneOver = false;
      } break;
      case 'drop':{
        console.log("drop")
        this.hasBaseDropZoneOver = false;
      } break;
      case 'done':{
        let initialize = false;

        if (output.file && output.file.response && this.screenState != "FINISHED") {
          this.screenState = "FINISHED";
          this.uploadResponse = output.file.response;
          console.log(this.uploadResponse)

          //if error occurs
          if(this.uploadResponse.hasOwnProperty('code')) {
            initialize = true;
            console.log("response " + this.uploadResponse.description);
            this.notificationService.displayError(this.uploadResponse.description);
            this.uploadInput.emit({type:"cancelAll"})
            this.initUploader();
          }else{
            this.initUploader();
            this.GetTheJob();
          }
          this.uploadInput.emit({type:"removeAll"})
        }

        if (this.screenState != "FINISHED" && !initialize) {
          this.screenState = "UPLOADING";
        }
      } break;
      case 'rejected':{
        console.log("rejected",output)
        this.uploadInput.emit({type:"removeAll"})
        if (output.file.size > this.sizeLimit) {
          this.notificationService.largeFileToUpload();
        } else if (!(/\.(gif|jpg|jpeg|png|pdf)$/i).test(output.file.name)){
          this.notificationService.fileTypeNotMatchToUpload();
        }
      } break;
      case 'cancelled':{
        console.log("cancelled")
      } break;
       */
    }

  }

  successCallbackFunction(){
    console.log("successCallbackFunction");
  }


  public onCancel() {
    // if (this.uploadFile !== null) {
    //   console.log("upload cancelled...");
    //   this.uploadInput.emit({type:"cancel",id:this.jobIDParameter.toString()})
    // }

    //cancel Box or Drive upload
    if(this.cloudFile.xhr) {
      this.cloudFile.xhr.abort();
      this.cloudFile.xhr = null;

      this.cloudFile.status = "";
      this.cloudFile.progress = 0;
    }
  }

  public deleteJob() {
    //cancel upload
    this.onCancel();

    this.screenState = "";
    this.resetUpload();
    // this.uploadFile = null;

    console.log("delete job: "+ this.theJob.id);
    this.subscriptions.push(this.jobsApi.jobsIdDelete(this.authorization.getAccessToken(), this.theJob.id).subscribe(
      response => {
        //this.notificationService.jobDeleted(jobName);
        // if(response.code==200) location.reload();
        //  console.log("job deleted " + response.code);
      },
      err => {
        // Log errors if any
        console.log(err);
        //this.notificationService.displayError(err);
      }
    ));

    //send hideModal to component outer modal
    this.hideModal.emit({
      value: true
    })
  }

  private resetUpload(){
    // if(this.options !=null) {
    //   $('#file-upload').val('');
    // }
    // else if (this.cloudOptions != null) {
    //   $('#file-upload-cloud').val('');
    // }
  }

  private initUploader() {
    this.screenState = "INITIAL";
    this.cloudOptions = null;

    // Clear any previous Uppy plugins and re-configure
    const existingXhr = this.uppy.getPlugin('XHRUpload');
    if (existingXhr) {
      this.uppy.removePlugin(existingXhr);
    }

    // Configure XHRUpload with the job endpoint
    this.uppy.use(XHRUpload, {
      endpoint: Config.WEBSERVICEURL + '/jobs/' + this.jobIDParameter + '/documents',
      method: 'POST',
      formData: true,
      fieldName: 'file',
      bundle: false,
    });

    // Set headers just before upload
    this.uppy.on('upload', async () => {
      const token = this.authorization.getAccessToken();
      const xhr = this.uppy.getPlugin<XHRUpload<any, any>>('XHRUpload');
      xhr?.setOptions({
        headers: {
          access_token: `${token}`,
        }
      });
    });

    // Handle upload completion
    this.uppy.on('complete', async (result) => {
      const ok = result.successful ?? [];
      if (ok.length > 0) {
        this.uppy.clear();
        this.GetTheJob(); // Refresh the job to show newly uploaded documents
      }
    });
  }


  beforeUpload(uploadingFile: any/*UploadFile*/):void {
    //console.log("file: " + uploadingFile.originalName);
    this.cloudFile.fileName = uploadingFile.name;
    this.cloudFile.fileSize = this.humanizeBytes(uploadingFile.size);

    if (uploadingFile.size > this.sizeLimit) {
      // this.uploadInput.emit({type:"cancel",id:this.jobIDParameter.toString()})
      this.notificationService.largeFileToUpload();
      this.resetUpload();
    }

    let match = (/\.(gif|jpg|jpeg|png|pdf)$/i).test(uploadingFile.name);
    console.log("file type match: " + match);

    if (!match) {
      // this.uploadInput.emit({type:"cancel",id:this.jobIDParameter.toString()})
      this.notificationService.fileTypeNotMatchToUpload();
      this.resetUpload();
    }
  }


  handleUpload(data:any):void {
    let initialize = false;

    setTimeout(() => {
      this.zone.run(() => {

        // this.uploadFile = data;

        if (data && data.response && this.screenState != "FINISHED") {

          this.screenState = "FINISHED";
          this.uploadResponse = JSON.parse(data.response);

          //if error occurs
          if(this.uploadResponse.hasOwnProperty('code')) {
            initialize = true;
            console.log("response " + this.uploadResponse.description);
            this.notificationService.displayError(this.uploadResponse.description);
            this.initUploader();
          }else{
            this.initUploader();
            this.GetTheJob();
          }

        }

        if (this.screenState != "FINISHED" && !initialize) {
          this.screenState = "UPLOADING";
        }

      });

    });

  }


  private onNavigationEvent(event:NavigationEvent) {
    switch (event.acton) {
      case "CANCEL_COMBINE":
        this.RedirectReferredPage();
        break;
      case "COMBINE_SAVE":
      {
        this.CombineAndSave();
        break;
      }
    }
  }


  public CombineAndSave(){
    if(this.theJob.name != this.jobNewName)
      this.updateLabels();
    else
      this.combine();
  }

  combine(){
    let docIds:any = this.sortableItems.map((x:any)=>x.id);

    if(docIds.length > 1) {
      //no action
      this.subscriptions.push(this.jobsApi.jobsIdActionsCombinePut(this.authorization.getAccessToken(), this.jobIDParameter, docIds.toString()).subscribe(
        (response: Communication.Job) => {
          console.log("pdf files merged...");
          this.notificationService.documentsCombined();
          this.RedirectReferredPage();

        }, //Bind to view
        (err: any) => {
          // Log errors if any
          console.log(err);
          this.notificationService.displayError(err);
        }
      ));
    }
    else
      this.notificationService.uploadedFilesShoudBeMoreThanOne();
  }

  deleteDocument(documentId:number, index:number){
    this.subscriptions.push(this.documentsApi.documentsIdDelete(this.authorization.getAccessToken(), documentId).subscribe(
      (response: any) => {
        console.log("Document deleted");

        this.sortableItems.splice(index, 1);
        this.reachedMaxUpload = this.sortableItems.length >= 10;
      }, //Bind to view
      (err: any) => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
  }

  // CDK Drag-Drop handler for reordering documents
  drop(event: CdkDragDrop<Communication.Document[]>) {
    moveItemInArray(this.sortableItems, event.previousIndex, event.currentIndex);
  }

  public RedirectReferredPage(){
    let _thisRedirectedRefer=this;
    console.log("RedirectReferredPage");
    if(this.returnUrl != ''){
      window.location.href = this.returnUrl;
      console.log("this.returnUrl != '' this.returnUrl "+this.returnUrl);
    }else{
      //this.location.back(); // çağıran sayfaya dönmek için
      setTimeout(function(){ _thisRedirectedRefer.location.back();}, 1000);
    }
  }

  ngOnDestroy(){
    $('.modal-backdrop').remove(); //browser ileri-geri tuşuna basıncaki kırıklığı önlemek

    // Tear down Uppy (Dashboard + Drive/Box plugins) on route change and remove
    // any orphaned native Google Picker overlay Google injects on document.body.
    this.uppy?.destroy();
    $('.picker-dialog, .picker-dialog-bg').remove();

    this.subscriptions.forEach(
      (s: Subscription) => s.unsubscribe()
    );
  }

}
